<template>
  <div>
    <flash-message :add-bottom-margin="true" size="is-size-7"></flash-message>
    <div class="hp-card review-card" v-bind="{...(itemProps? {'itemprop': 'review', 'itemscope':true, 'itemtype': 'http://schema.org/Review' }:{})}">
      <div class="is-flex falign-center">
        <router-link :to="{ name: 'UserProfile', params: { uuid: review.author_id } }">
          <avatar :class="{'margin-right-28':!isMobile, 'margin-right-8':isMobile}" backgroundColor="#f9f9fa" color="#29357f" :customStyle="{'font-weight': 'bold' ,...avatarStyle}" :username="review.author"/>
        </router-link>
        <!-- Start: ITEM PROP -->
        <template v-if="itemProps">
          <div hidden itemprop="author" itemscope itemtype="http://schema.org/Person">
            <span itemprop="name" v-html="review.author"></span>
          </div>
          <div hidden itemprop="itemReviewed" itemscope itemtype="http://schema.org/LocalBusiness">
            <div itemprop="name" v-html="review.business_name"></div>
          </div>
          <p itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">
            <span hidden itemprop="worstRating">1</span>
            <span hidden itemprop="ratingValue" v-html="review.review_rating"></span>
            <span hidden itemprop="bestRating">5</span>
          </p>
        </template>
        <!-- End: ITEM PROP -->
        <div>
          <div class="has-text-weight-bold" :class="{'font-size-16':!isMobile, 'font-size-12':isMobile}">
            <router-link :to="{ name: 'UserProfile', params: { uuid: review.author_id } }" class="color-gray">
              {{ review.author }}
            </router-link>
          </div>
          <div class="is-italic">{{ review.author_total_reviews_count }} {{ pluralize('review', review.author_total_reviews_count) }} | Active since {{ toMonthYear(review.author_created_date) }}</div>
        </div>
      </div>
      <div :class="{'margin-left-78':!isMobile, 'margin-left-1':isMobile, 'margin-top-8':!isMobile}">
        <div>
          <rating :stars="review.review_rating"/>
          {{ toDayMonthYearTime(review.created_at) }}
        </div>
        <div v-if="review.attachments.length">
          <review-attachments class="rc__attachments" :attachments="review.attachments"/>
          {{ review.attachments.length }} {{ pluralize('photo', review.attachments.length) }}
        </div>
        <div v-bind="{...(itemProps? {'itemprop': 'name' }:{})}" v-html="review.review_title" class="has-text-weight-bold"
             :class="{'margin-top-24': !isMobile, 'font-size-16': !isMobile, 'margin-bottom-12':!isMobile, 'font-size-12': isMobile, 'margin-top-16': isMobile, 'margin-bottom-5': isMobile}">
        </div>
        <meta :content="review.created_at" itemprop="datePublished" v-if="itemProps">
        <div class="margin-bottom-15 rc__body" :class="{'font-size-12':isMobile}" v-bind="{...(itemProps? {'itemprop': 'reviewBody' }:{})}" v-html="review.review_content"></div>
        <div>
                  <span class="pill" v-if="review.nps_rating != null">
                    <img :src="`/static/img/reviews/${npsCat(review.nps_rating)}.svg`"/>
                    {{ npsCustomerMood(review.nps_rating) }}
                  </span>
          <span href="#" class="pill" v-if="isReviewReported(review)">
                    Reported
                  </span>
        </div>
        <div class="separator"></div>
        <div class="rc__action-row">
          <div class="has-text-weight-semibold font-size-12">
            Reply ({{ messagesCount }})
          </div>
          <div>
            <tooltip v-if="shareLink" :tooltipRight="0" :tooltipTop="5" :openOnClick="true" class="is-inline-block position-relative margin-right-25" tooltipClass="shareTooltip">
              <template #icon>
                <a href="#">
                  <img class="valign-sub"
                       src="/static/img/reviews/share.png"
                       srcset="/static/img/reviews/share@2x.png 1.5x,
                              /static/img/reviews/share@2x.png 2x,
                              /static/img/reviews/share@3x.png 3x"/>
                </a>
              </template>
              <div>
                <a :href="socialLink.url" rel="nofollow" target="_blank" v-for="socialLink in socialLinks" class="social-link">
                  <img :src="`/static/img/social/${socialLink.image}.svg`"/>
                  <span></span>
                </a>
              </div>
            </tooltip>
            <a v-if="!isReviewReported(review)" @click.prevent="handleReportReview(review.permalink)" href="#">
              <img class="valign-sub"
                   src="/static/img/reviews/report.png"
                   srcset="/static/img/reviews/report@2x.png 1.5x,
                            /static/img/reviews/report@2x.png 2x,
                            /static/img/reviews/report@3x.png 3x"/>
            </a>
            <router-link v-if="detailLink" :to="{ name: 'Reviewdetail', params: { business: review.business_slug, permalink: review.permalink } }" :class="{'hp-btn-link':!isMobile, 'link--v2':isMobile}" class="rc__open-review">
              <template v-if="!isMobile">See more</template>
              <template v-else>Show more</template>
            </router-link>
          </div>
        </div>
        <div class="separator"></div>
        <div class="reply-card" v-for="message in messages">
          <div :class="{'is-flex': !isMobile, 'jcontent-space-between': !isMobile}">
            <div class="has-text-weight-bold">{{ message.from }}’s reply</div>
            <div class="color-gray2 is-italic" :class="{'font-size-11':isMobile}">{{ toDayMonthYearTime(message.created_at) }}</div>
          </div>
          <div class="line-height-22 margin-top-10" v-html="message.body"></div>
        </div>
      </div>
      <div :class="{'margin-left-78':isDesktop, 'margin-left-1':isMobile}">
        <div class="reply-box" v-if="replyBox && isLoggedIn && isReviewOwner">
          <div class="loaderr" v-if="isPostingReply">
            <loader/>
          </div>
          <div>Add your reply</div>
          <wysiwyg :ref="`addReplyWysiwyg${review.permalink}`"
                   v-model="replyText"
                   name="replyText"
                   :pre-saved-responses="false"
                   :shouldClear="clearEditor"
                   :value="replyText"
                   class="wysiwyg"/>
          <div :class="{'has-text-right':!isMobile}">
            <label class="radio c-radio">
              <input v-model="replyType" type="radio" name="replyType" value="1" :disabled="isPostingReply">
              Public reply
            </label>
            <label class="radio c-radio">
              <input v-model="replyType" type="radio" name="replyType" value="2" :disabled="isPostingReply">
              Private reply
            </label>
            <button class="hp-btn-primary" :disabled="isPostingReply || !replyText.trim().length" @click="postReply">REPLY NOW</button>
          </div>
          <div class="font-size-10 margin-top-15" v-if="!isTablet">Please note that your reply will be displayed <span class="has-text-weight-semibold">publicly</span> and must comply with Hellopeter’s local content guidelines. <a href="#"
                                                                                                                                                                                                                                       class="link--v2">Terms
            of service</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Avatar from 'vue-avatar'
import {misc, moment as momentHp, auth} from '@/mixins'
import Rating from './Rating'
import ReviewAttachments from './ReviewAttachments'
import Wysiwyg from './Wysiwyg'
import Tooltip from './Tooltip'
import FlashMessage from './FlashMessage'
import Loader from './Loader'
import axios from "axios";

export default {
  name: 'ReviewCardV2',
  components: {
    Avatar,
    Rating,
    ReviewAttachments,
    Tooltip,
    Wysiwyg,
    FlashMessage,
    Loader
  },
  mixins: [misc, momentHp, auth],
  props: {
    review: {
      type: Object,
      required: true
    },
    detailLink: {
      type: Boolean,
      default: false
    },
    shareLink: {
      type: Boolean,
      default: true
    },
    replyBox: {
      type: Boolean,
      default: true
    },
    messagesCount: {
      type: Number,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    itemProps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      clearEditor: 0,
      replyText: '',
      replyType: 1,
      isPostingReply: false
    }
  },
  created () {
    window.events.$on('reportedReviewComplete', (data) => {
      if (data.header === 'is-success' && data.data.review_id === this.review.id) {
        this.$emit('update:review', {...this.review, business_reporting: data.data})

        modal({
          'title': 'Thanks for reporting this review',
          'body': `<p>You'll hear back from us within the next two business days.</p>
                  <p style="margin-top: 6px;">While you're waiting, check out what happens when <br/>you <a class="link--v2" target="__blank" href="${process.env.REPORT_PAGE_URL}">report a review</a> </p>`,
          'btn_action_title': 'OK',
          'show_btns': true,
          'show_cancel_btn': false,
          'show_close_btn': false,
          'setWidthAuto': true,
          'isReportSucsess': true,
        })
      }
    })
  },
  destroyed () {
    window.events.$off('reportedReviewComplete')
  },
  computed: {
    avatarStyle () {
      if (!this.isMobile) {
        return {'font-size': '18px'}
      }
      return {'font-size': '16px', 'width': '40px', 'height': '40px'}
    },
    isReviewOwner () {
      const loggedInProfile = localStorage.getItem('profile_id')
      if (typeof loggedInProfile !== 'undefined' && loggedInProfile !== null && this.review !== null && typeof this.review.author_id !== 'undefined') {
        return loggedInProfile === this.review.author_id
      }

      return false
    },
    socialLinks () {
      return [
        {
          image: 'fb',
          url: `https://www.facebook.com/sharer.php?u=${process.env.APP_URL}/${this.business}/reviews/${this.review.permalink}`
        },
        {
          image: 'twitter',
          url: `https://twitter.com/share?url=${process.env.APP_URL}/${this.business}/reviews/${this.review.permalink}&text=Check%20out%20this%20review%20on%20%40hellopetercom`
        },
        {
          image: 'linkedin',
          url: `https://www.linkedin.com/shareArticle?mini=true&url=${process.env.APP_URL}/${this.business}/reviews/${this.review.permalink}`
        }
      ]
    }
  },
  methods: {
    isReviewReported (review) {
      return review.business_reporting && review.business_reporting.status !== 'RESOLVED'
    },
    npsCustomerMood (npsScore) {
      let mood
      switch (this.npsCat(npsScore)) {
        case 'detractors':
          mood = 'Unhappy customer'
          break;
        case 'passives':
          mood = 'Undecided customer'
          break;
        case 'promoters':
          mood = 'Happy customer'
          break;
        default:
          mood = ''
      }
      return mood
    },
    handleReportReview (reviewPermalink) {
      modal({
        title: 'Report review',
        body: '',
        btn_action_title: 'REPORT REVIEW',
        show_btns: true,
        show_cancel_btn: false,
        show_close_btn: true,
        task: 'reportReviewCallback',
        setWidthAuto: true,
        isReportReview: true,
        reviewSlug: reviewPermalink,
        businessSlug: this.business,
        producer: {}
      })
    },
    postReply () {
      if (this.replyText.trim().length) {
        this.isPostingReply = true
        axios.post(`/consumer/reviews/${this.review.permalink}/reply`, {
          reply: this.replyText,
          public: this.replyType == 1
        })
          .then(({data}) => {
            this.recacheReviewDetail(this.business, this.review.permalink) //Review detail page

            this.replyText = ''
            ++this.clearEditor
            this.replyType = 1
            this.$emit('update:messages', data.messages)
            //this.reviewDetail = data
            /*if (typeof data.messages !== 'undefined') {
              this.messages = data.messages
            }*/

            //this.clearReplyBox = !this.clearReplyBox
            flash('Review message posted successfully.', 'is-success')
          })
          .catch(_ => {
            flash('There was an error replying to this review. Please try again later!', 'is-danger')
          })
          .finally(_ => {
            this.isPostingReply = false
          })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.review-card {
  padding: 25px 43px 21px 23px;
  margin-bottom: 27px;

  &:not(:last-child) {
    margin-bottom: 26px;
  }

  @include mobile {
    font-size: 11px;
    padding: 9px 9px 10px 7px;
    margin-bottom: 8px;
    border: 0.3px solid #c9c9ca;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.05);
    border-radius: 7px;
  }

  > > > .star-new {
    font-size: 10px;
    display: inline-block;
    margin-left: -3px;
    margin-right: 18px;

    @include mobile {
      margin-right: 5px;
      margin-top: 12px;
    }

    ul {
      width: auto;
    }
  }

  .rc__attachments {
    display: inline-block;
    margin-top: 15px;

    > > > img {
      width: 46px;
      padding-right: 6px;

      @include mobile {
        width: 30px;
        margin-top: -3px;
      }
    }
  }

  .rc__body {
    word-break: break-word;
    white-space: pre-wrap;
  }

  .pill {
    font-size: 12px;
    color: map-get($colors, 'gray') !important;
    border: 1px solid rgba(88, 89, 91, 0.32);
    border-radius: 12.5px;
    padding: 4px 8px 1px 6px;

    @include mobile {
      padding: 2px 6px 1px 7px;
    }

    img {
      width: 17px;
      height: 16px;
      vertical-align: sub;
      margin-right: 4px;
    }
  }

  .separator {
    margin-top: 0;
    margin-bottom: 11px;

    @include mobile {
      margin-bottom: 9px;
    }
  }

  .rc__action-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    height: 35px;

    @include mobile {
      height: 27px;
    }

    .rc__open-review {
      width: 130px;
      margin-left: 6px;
      padding: 3px 0;
      text-transform: none;
      font-weight: normal;

      @include mobile {
        padding-right: 16px;
        font-size: 12px;
        margin-left: 10px;
        background: url("/static/img/arrows/arrow_right_blue.svg") no-repeat right 0 top 5px/ 9px;
      }
    }
  }

  .reply-card {
    background-color: map-get($colors, 'gray-light');
    margin-top: 15px;
    padding: 7px 23px 14px 25px;
    border-radius: 10px;

    &:nth-of-type(odd) {
      border: 0.5px solid rgba(88, 89, 91, 0.32);
      background-color: #fff;
    }

    @include mobile {
      font-size: 12px;
      padding: 9px 9px 4px 10px;
      margin-top: 14px;
    }
  }

  .reply-box {
    border-radius: 10px;
    background-color: map-get($colors, 'gray-light');
    padding: 10px 23px 16px 19px;
    margin-top: 13px;
    margin-bottom: 77px;
    position: relative;

    @include tablet {
      margin-bottom: 2px;
    }

    @include mobile {
      margin-bottom: 4px;
    }

    @include mobile {
      padding: 12px 9px 7px 9px;
    }

    .loaderr {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: map-get($colors, 'gray-light');
      display: flex;
      align-items: center;
      z-index: 9;
      opacity: 0.5
    }

    .wysiwyg {
      border-color: #c9c9ca;
      margin: 4px 0 15px;
      font-size: 12px;

      & > > > .trix-button-row {
        background-color: #fff !important;
        border-bottom: 1px solid #c9c9ca;
      }

      & > > > trix-toolbar .trix-button-group {
        margin-top: 5px !important;
        margin-bottom: 4px;
        padding-left: 6px;
      }

      & > > > trix-toolbar .trix-button--icon-bold {
        width: 15px;
        margin-right: 3px;
      }

      & > > > trix-toolbar .trix-button--icon-italic {
        width: 15px;
        margin-right: 3px;
      }

      & > > > trix-toolbar .trix-button--icon-bullet-list, & > > > trix-toolbar .trix-button--icon-number-list {
        width: 21px;
        margin-right: 3px;
      }

      & > > > trix-toolbar .trix-button--icon-bullet-list::before, & > > > trix-toolbar .trix-button--icon-number-list::before {
        width: 15px;
        left: 3px;
      }

      & > > > trix-editor {
        padding: 10px;
        min-height: 86px;
      }

      & > > > trix-editor:empty:not(:focus)::before {
        color: rgba(88, 89, 91, 0.32);
      }
    }

    .c-radio {
      margin-left: 16px;

      @include mobile {
        margin-left: 32px;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .hp-btn-primary {
      width: 139px;
      height: 35px;
      margin-left: 15px;

      @include mobile {
        width: 100%;
        margin-top: 11px;
        margin-left: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.shareTooltip.tooltip.popover {
  width: 92px;

  .popover-inner {
    padding: 8px 0 0 8px;
    border-radius: 17px;
    border-top-left-radius: 0;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.1);

    .social-link {
      width: 20px;
      height: 20px;
      margin-right: 8px;

      span {
        left: -1px;
        top: -1px;
        bottom: -1px;
        right: -1px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ReviewCardV2.vue